import React from "react";
import {readableDate} from "../../../../utils";
import {Link} from "react-router-dom";

function SoldRow({value, finance, activeTab}) {
  return (
      <tr
          className="clickable"
          onClick={() => window.open("/editvehicle/" + value.id, "_self")}
          key={value.id}
      >
        <td data-testid={"vehicle-registration"}>
            <Link to={`/editvehicle/${value.id}`}>
              <span className="registration-field">
              {value.registration}
              </span>
            </Link>
        </td>
        {activeTab === 'fleet' &&
            <td data-testid={"vehicle-fleetnum"}>{value.fleet_number}</td>
        }
        <td data-testid={"vehicle-make"}>{value.make}</td>
        <td data-testid={"vehicle-model"}>{value.model}</td>
        <td data-testid={"vehicle-variant"}>{value.variant}</td>
        <td data-testid={"vehicle-vin"}>{value.vin_number}</td>
        <td data-testid={"vehicle-type"}>{value.type}</td>
        <td data-testid={"vehicle-solddate"}>{readableDate(finance.sold_date)}</td>
        <td data-testid={"vehicle-soldprice"}>
          £{parseFloat(finance.sold_price).toFixed(2)}
        </td>
        <td data-testid={"vehicle-salecomments"}>{finance.sale_comments}</td>
        <td data-testid={"vehicle-owner"}>{value.owner ? value.owner : "None Set"}</td>
        <td data-testid={"vehicle-financecomments"}>{finance.finance_comments}</td>
        <td data-testid={"finance-sale-customer"}>{finance.sale_customer ? finance.sale_customer.display_name : ""}</td>
      </tr>
  )
}

export default SoldRow;
